var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"text-none rounded-pill px-5",attrs:{"color":_vm.powerTripDarkBlue,"outlined":"","disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.emitClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }